module.exports = __webpack_public_path__ + "static/media/video.74183b09.webm";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyTurfClub/video.webm
// module id = 209
// module chunks = 0